<div class="fg-view-container fg-view-container-bg ">
  <div class="layout-padding fg-col-body">
    <div class="p-grid p-mt-3">
      <div class="p-col-12 input-container">
        <div class="input-cell">
          <label>
            Essentials
          </label>
        </div>
        <div style="margin-right: 1rem;">
          <button [disabled]="newCreator.firstName === '' ?  true : false" 
            pButton label="Preview Profile" 
            class="p-button-hollow"
            (click)="showPreview()">
          </button>
        </div>
        <div *ngIf="!this.newCreator.publishCreator">
          <button [disabled]="newCreator.firstName === '' ?  true : false" 
            pButton 
            label="Publish Creator" 
            class="p-button-secondary" 
            (click)="handlePublishCreator()">
          </button>
        </div>
        <div *ngIf="this.newCreator.publishCreator">
          <button [disabled]="newCreator.firstName === '' ?  true : false" 
            pButton 
            label="Revoke Creator" 
            class="p-button-outlined" 
            (click)="handlePublishCreator()">
          </button>
        </div>
      </div>
      <div class="p-col-12 input-container">
        <div class="input-cell">
          <label>Creator Name</label>
          <input type="text" name="firstName" [(ngModel)]="newCreator.firstName" (ngModelChange)="isDirty = true" maxlength="30" />
        </div>
      </div>
      <div class="p-col-12 input-container">
        <div class="input-cell height">
          <label>Description</label>
          <textarea type="text" name="bio" [(ngModel)]="newCreator.bio" (ngModelChange)="isDirty = true" maxlength="1000"></textarea>
        </div>
      </div>
      <div class="input-container p-col-12">
        <div class="input-cell">
          <label>Profile Banner</label>
          <!-- <div class="select-image-subheader">JPG or PNG image,</div> -->
          <cropper [img]="newCreator?.headerMedia?.url" (setImage)="setImage($event,'headerMedia')" width="519px"
            height="142px" [finalWidth]="1600" [finalHeight]="400" [marginAuto]="false" footer="Update Image"
            buttoncolor="true" ></cropper>
        </div>
      </div>
      <div class="clearfix"></div>

      <div class="input-container p-col-12">
        <div class="input-cell">
          <label>Profile Image</label>
          <!-- <div calss="select-image-subheader">JPG or PNG image,</div> -->
          <cropper [img]="newCreator?.profileMedia?.url" (setImage)="setImage($event,'profileMedia')" width="170px"
            height="170px" [finalWidth]="720" [finalHeight]="720" [marginAuto]="false" footer="Update Image" ></cropper>
        </div>
      </div>
      <div class="clearfix"></div>
      <!-- </div> -->
      <div class="input-container p-col-6">
        <div class="input-cell">
          <label>Website</label>
          <input type="text" name="website" [(ngModel)]="newCreator.website" placeholder="https://fan.guru" (ngModelChange)="isDirty = true" />
        </div>
      </div>
      <div class="input-container p-col-6">
        <div class="input-cell">
          <label>Instagram handle</label>
          <span class="input-flex flex-left flex-right">
            <span class="input-mask">@</span>
            <input type="text" name="instagram" [(ngModel)]="newCreator.instagram" (ngModelChange)="isDirty = true"/>
          </span>
        </div>
      </div>
      <div class="input-container p-col-6">
        <div class="input-cell">
          <label>Facebook handle</label>
          <span class="input-flex flex-left flex-right">
            <span class="input-mask">@</span>
          <input type="text" name="facebook" [(ngModel)]="newCreator.facebook" placeholder="https://fan.guru" (ngModelChange)="isDirty = true"/>
        </span>
        </div>
      </div>
      <div class="input-container p-col-6">
        <div class="input-cell">
          <label>X handle</label>
          <span class="input-flex flex-left flex-right">
            <span class="input-mask">@</span>
            <input type="text" name="twitter" [(ngModel)]="newCreator.twitter" (ngModelChange)="isDirty = true" />
          </span>
        </div>
      </div>
      <div class="input-container p-col-6">
        <div class="input-cell">
          <label>Twitch handle</label>
          <span class="input-flex flex-left flex-right">
            <span class="input-mask">@</span>
            <input type="text" name="twitch" [(ngModel)]="newCreator.twitch" (ngModelChange)="isDirty = true"/>
          </span>
        </div>
      </div>
      <div class="input-container p-col-6">
        <div class="input-cell">
          <label>Youtube handle</label>
          <span class="input-flex flex-left flex-right">
            <span class="input-mask">@</span>
          <input type="text" name="youtube" [(ngModel)]="newCreator.youtube" (ngModelChange)="isDirty = true"/>
          </span>
        </div>
      </div>
      <div class="input-container p-col-6">
        <div class="input-cell">
          <label>Tiktok handle</label>
          <span class="input-flex flex-left flex-right">
            <span class="input-mask">@</span>
          <input type="text" name="tiktok" [(ngModel)]="newCreator.tiktok" (ngModelChange)="isDirty = true" />
          </span>
        </div>
      </div>
      <div class="input-container p-col-6">
        <div class="input-cell">
          <label>Spotify URL</label>
          <input type="text" name="spotify" [(ngModel)]="newCreator.spotify" placeholder="https://fan.guru" (ngModelChange)="isDirty = true" />
        </div>
      </div>      
      <div class="input-container p-col-6">
        <div class="input-cell">
          <label>Discord URL</label>
          <input type="text" name="discord" [(ngModel)]="newCreator.discord" placeholder="https://fan.guru" (ngModelChange)="isDirty = true" />
        </div>
      </div>
      <div class="input-container p-col-6">
        <div class="input-cell">
          <label>Threads handle</label>
          <span class="input-flex flex-left flex-right">
            <span class="input-mask">@</span>
          <input type="text" name="threads" [(ngModel)]="newCreator.threads" (ngModelChange)="isDirty = true" />
          </span>
        </div>
      </div>
      <div class="input-container p-col-6">
        <div class="input-cell">
          <label>IMDB handle</label>
          <span class="input-flex flex-left flex-right">
            <span class="input-mask">@</span>
          <input type="text" name="imdb" [(ngModel)]="newCreator.imdb" placeholder="nm0000000" (ngModelChange)="isDirty = true" />
          </span>
        </div>
      </div>
      <div class="input-container p-col-12" *ngFor="let template of colorsTemplate">
        <div class="input-cell">
          <label>{{ template.label }}</label>
          <span class="input-flex">
            <input pInputText [name]="template.prop" type="text" [(ngModel)]="newCreator[template.prop]"
              (ngModelChange)="isDirty = true" />
            <p-colorPicker styleClass="rounded-color-picker" [name]="template.prop" width="100px!important"
              [(ngModel)]="newCreator[template.prop]"   (onChange)="onColorChange($event)" ></p-colorPicker>
              <button pButton type="button" class="p-button-text" label="Reset to Default" (click)="resetColor(template.prop)"></button>
            </span>
        </div>  
      </div>
    </div>  
    <div class="clearfix"></div>
  </div>

  <div class="fg-footer">
    <div class="btn-container" style="display: flex; gap: 1rem;">
      <button
        [disabled]="(newCreator.firstName === '' || !isDirty) ? true : false"
        pButton
        label="Save and Continue"
        class="fg-button"
        (click)="onSave()"
      ></button>


    </div>
  </div>
</div>

<!-- Preview Modal -->
<p-dialog
  [(visible)]="showPreviewModal"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [showHeader]="false"
  [dismissableMask]="true"
  [style]="{ maxWidth: '800px' }"
  [contentStyle]="{ padding: '0' }"
  styleClass="preview-modal"
>
  <div class="preview-container">
    <!-- Banner Section -->
    <div class="preview-banner" [style.background-image]="newCreator.headerMedia?.url ? 'url(' + newCreator.headerMedia.url + ')' : 'none'">
      <div class="banner-overlay">
        <button class="back-button" (click)="showPreviewModal = false">
          <i class="pi pi-arrow-left"></i>
          Back
        </button>
        
        <!-- Creator Info in Banner -->
        <div class="banner-content">
          <div class="creator-info">
            <div class="profile-image-container">
              <img 
                [src]="newCreator.profileMedia?.url || 'assets/images/default-profile.png'" 
                alt="Profile"
                class="profile-image"
              />
            </div>
            <div class="creator-details">
              <h1 class="creator-name">{{ newCreator.firstName || 'Creator Name' }}</h1>
              <p class="creator-bio">{{ newCreator.bio || 'Creator description will appear here' }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Navigation Tabs -->
    <div class="preview-navigation">
      <div class="nav-tabs">
        <div class="nav-tab active">About</div>
        <div class="nav-tab">Posts</div>
        <div class="nav-tab">Fan Wall</div>
        <div class="nav-tab">Requests</div>
        <div class="nav-tab">Schedule</div>
        <div class="nav-tab">Communities</div>
        <div class="nav-tab">Contests</div>
      </div>
    </div>

    <!-- Content Area -->
    <div class="preview-content">
      <div class="content-section">
        <h3>About</h3>
        <p>{{ newCreator.bio || 'No description available' }}</p>
        
        <div class="social-links" *ngIf="newCreator.website || newCreator.instagram || newCreator.facebook || newCreator.twitter || newCreator.youtube || newCreator.tiktok">
          <h4>Social Links</h4>
          <div class="social-grid">
            <div class="social-item" *ngIf="newCreator.website">
              <i class="pi pi-globe"></i>
              <span>{{ newCreator.website }}</span>
            </div>
            <div class="social-item" *ngIf="newCreator.instagram">
              <i class="pi pi-instagram"></i>
              <span>@{{ newCreator.instagram }}</span>
            </div>
            <div class="social-item" *ngIf="newCreator.facebook">
              <i class="pi pi-facebook"></i>
              <span>@{{ newCreator.facebook }}</span>
            </div>
            <div class="social-item" *ngIf="newCreator.twitter">
              <i class="pi pi-twitter"></i>
              <span>@{{ newCreator.twitter }}</span>
            </div>
            <div class="social-item" *ngIf="newCreator.youtube">
              <i class="pi pi-youtube"></i>
              <span>@{{ newCreator.youtube }}</span>
            </div>
            <div class="social-item" *ngIf="newCreator.tiktok">
              <i class="pi pi-video"></i>
              <span>@{{ newCreator.tiktok }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
